// src/context.ts
import React from "react";
var PressResponderContext = React.createContext(null);
PressResponderContext.displayName = "PressResponderContext";

export {
  PressResponderContext
};
